var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Checkbox, CheckboxGroup, VStack } from '@chakra-ui/react';
import React from 'react';
import { useController } from 'react-hook-form';
var RadioFieldMultiple = function (_a) {
    var options = _a.options, name = _a.name, control = _a.control, containerProps = _a.containerProps, props = __rest(_a, ["options", "name", "control", "containerProps"]);
    var _b = useController({
        name: name,
        control: control,
    }).field, onChange = _b.onChange, value = _b.value;
    return (React.createElement(CheckboxGroup, { value: value, onChange: onChange },
        React.createElement(VStack, __assign({ alignItems: 'start' }, containerProps), options === null || options === void 0 ? void 0 : options.map(function (option) { return (React.createElement(Checkbox, __assign({ key: "".concat(name, "_").concat(option === null || option === void 0 ? void 0 : option.value), as: 'div', colorScheme: 'primary', gap: 'sm', size: 'lg', value: option.value }, props), option.label)); }))));
};
export default RadioFieldMultiple;
//# sourceMappingURL=RadioFieldMultiple.js.map